
          import "SwitchBase.styles_1e0edzo.linaria.css";
          import { styled } from "@linaria/react";
import { focusStyle, themeTokens } from "@carvana/showroom-css-theme";
export const SWITCH_WIDTH = "2.75em";
export const SWITCH_HEIGHT = "1.375em";
export const THUMB_SIZE = "1.5em";

const colorize = color => {
  const theme = themeTokens;
  let result = theme.color.green["2"];

  switch (color) {
    case "primary":
      result = theme.color.blue["2"];
      break;

    case "success":
    case "default":
      result = theme.color.green["2"];
      break;

    case "error":
      result = theme.color.red["2"];
      break;

    case "warning":
      result = theme.color.yellow["2"];
      break;

    case "master":
      result = theme.color.grey["5"];
      break;

    default:
      if (color != null && color !== "") {
        result = color;
      }

  }

  return result;
};

export const Root = /*#__PURE__*/styled("label")({
  name: "Root",
  class: "r5nehpq",
  vars: {
    "r5nehpq-2": [props => colorize(props.color)]
  }
});
export const Input = /*#__PURE__*/styled("input")({
  name: "Input",
  class: "i1qe5t5c"
});
export const Track = /*#__PURE__*/styled("div")({
  name: "Track",
  class: "tpojou"
});
export const Thumb = /*#__PURE__*/styled("div")({
  name: "Thumb",
  class: "t1rw3jl8"
});
          